import { useState } from "react";
import GoogleMapSearch from "../../../../../common/components/google-map-search";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";


export default function LocationDetails({ shippingTypesDetails, packageItem, dropLocations, setDropLocation, pickupLocations, setPickupLocation, libraryData, quoteData, handleBackSteps, handleSteps, handleChange }: any) {


  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };
  return (
    <div className="flex flex-col justify-center items-center h-[450px] md:hidden"> {/* Visible only on mobile */}
      <div className=" h-full m-3 w-full">
        <div className="flex flex-col justify-center items-start p-5 space-y-5">
          <div className="text-xl font-semibold">Location Details</div>

          <div className="flex flex-wrap justify-between p-2 w-full space-y-4">
            {/* First "New Item" Section */}
            <div className="w-full"> {/* Full-width layout for mobile */}
              <div className="text-md font-normal p-4">Pickup Address</div>
              <div className="grid grid-cols-1 gap-4 w-full p-4">
                <div className="w-full border-b border-black rounded">
                  <input
                    required
                    type="text"
                    name="pickupContactName"
                    placeholder="Contact Name"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'pickupContactName');
                    }}
                    value={quoteData?.pickupContactName}
                  />
                </div>
                {/* <div className="w-full border-b border-black rounded">
                  <input
                    type="text"
                    name="pickupEmail"
                    placeholder="Email"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'pickupEmail');
                    }}
                    value={quoteData?.pickupEmail}
                  />
                </div> */}
                <div className="w-full border-b border-black rounded">
                  <input
                    required
                    maxLength={10}
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value.replace(/\D/g, ''), 'pickupMobileNumber');
                    }}
                    value={quoteData?.pickupMobileNumber}
                  />
                </div>
                {quoteData?.pickupMobileNumber && quoteData?.pickupMobileNumber?.length < 10 && (
                  <span className="text-red-600 text-xs">
                    Please enter a valid number.
                  </span>
                )}
                <div className="w-full rounded">
                  <GoogleMapSearch
                    required
                    setLocation={setPickupLocation}
                    location={pickupLocations}
                    placeholder="Pickup Address"
                  />
                </div>
                <div className="w-full rounded">
                  <textarea
                    name="additionainfo"
                    placeholder="Additional info"
                    className="w-full h-12 border-b border-black placeholder-black px-4 py-3"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'pickupAdditionaInfo');
                    }}
                    value={quoteData?.pickupAdditionaInfo}
                  />
                </div>
              </div>
            </div>

            {/* Second "New Item" Section */}
            <div className="w-full"> {/* Full-width layout for mobile */}
              <div className="text-md font-normal p-4">Drop Address</div>
              <div className="grid grid-cols-1 gap-4 w-full p-4">
                <div className="w-full border-b border-black rounded">
                  <input
                    required
                    type="text"
                    name="dropContactName"
                    placeholder="Contact Name"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'dropContactName');
                    }}
                    value={quoteData?.dropContactName}
                  />
                </div>
                {/* <div className="w-full border-b border-black rounded">
                  <input
                    type="text"
                    name="dropEmail"
                    placeholder="Email"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'dropEmail');
                    }}
                    value={quoteData?.dropEmail}
                  />
                </div> */}
                <div className="w-full border-b border-black rounded">
                  <input
                    required
                    maxLength={10}
                    type="text"
                    name="droMobileNumber"
                    placeholder="Mobile Number"
                    className="w-full px-2 py-2 placeholder-black"
                    onChange={(event: any) => {
                      handleChange(event.target.value.replace(/\D/g, ''), 'dropMobileNumber');
                    }}
                    value={quoteData?.dropMobileNumber}
                  />
                </div>
                {quoteData?.dropMobileNumber && quoteData?.dropMobileNumber?.length < 10 && (
                  <span className="text-red-600 text-xs">
                    Please enter a valid number.
                  </span>
                )}
                <div className="w-full rounded">
                  <GoogleMapSearch
                    required
                    setLocation={setDropLocation}
                    location={dropLocations}
                    placeholder="Drop Address"
                  />
                </div>
                <div className="w-full rounded">
                  <textarea
                    name="dropAdditionaInfo"
                    placeholder="Additional info"
                    className="w-full h-12 border-b border-black placeholder-black px-4 py-3"
                    onChange={(event: any) => {
                      handleChange(event.target.value, 'dropAdditionaInfo');
                    }}
                    value={quoteData?.dropAdditionaInfo}
                  />
                </div>
              </div>
            </div>

            {/* Shipping Option */}
            <div className="m-4 w-full">
              <div className="w-full border-b border-black rounded">
                <select
                  required
                  className="w-full rounded bg-opacity-0 py-2"
                  id="default"
                  onChange={(event: any) => {
                    handleChange(event.target.value, 'shipping');
                  }}
                  value={quoteData?.shipping}
                >
                  <option>Shipping Option *</option>
                  {libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
                    <option value={item.Text} key={index}>
                      {item.Text}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="w-full flex justify-end px-10 space-x-3">
            <button onClick={handleBackSteps} className="px-4 py-2 bg-primary text-light">
              Back
            </button>
            <button onClick={handleSteps} className="px-4 py-2 bg-primary text-light">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>


  );
}
